import { createContext, useContext, useState, useEffect } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("op_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("op_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("op_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("op_token");
    setUser(null);
  };

  // Where should this user land after auth?
  // `zone` (candidate|company) lets an admin choose which area to enter.
  const homeFor = (u, zone) => {
    if (!u) return "/login";
    if (u.role === "admin") {
      if (zone === "company") return "/company";
      if (zone === "candidate") return "/app/home";
      return "/admin";
    }
    if (u.status !== "approved") return "/pending";
    return u.role === "company" ? "/company" : "/app/home";
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, loading, homeFor }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
